import { Result } from "../Utility/Result"

export enum XOriginMessageType {
    oauthCode = "oauthCode",
    oauthSignedOut = "oauthSignedOut",
    unrecognized = "unrecognized"
}

export type XOriginMessage =
    | OAuthCodeMessage
    | OAuthSignedOutMessage
    | UnrecognizedMessage

interface OAuthCodeMessage {
    type: XOriginMessageType.oauthCode
    payload: Result<string>
}

interface OAuthSignedOutMessage {
    type: XOriginMessageType.oauthSignedOut
}

interface UnrecognizedMessage {
    type: XOriginMessageType.unrecognized
}

export function getTypedMessage(e: MessageEvent): XOriginMessage {
    if (
        e.origin !== window.origin ||
        e.data === null ||
        typeof e.data !== "object"
    ) {
        return {
            type: XOriginMessageType.unrecognized
        }
    }

    for (const t of Object.values(XOriginMessageType)) {
        if (t === e.data.type) {
            return e.data as XOriginMessage
        }
    }

    return {
        type: XOriginMessageType.unrecognized
    }
}
